import { useContext } from "react";
import LanguageContext from "../contexts/languagesContext";

export const useLangData = (properties) => {
  const { getData } = useContext(LanguageContext);
  return getData(properties);
};
